import { UserCircleIcon } from '@phosphor-icons/react'
import { ScoopText, ScoopRow } from '../../../../ui'
import styles from './UserMessage.module.scss'

export const UserMessage = ({ message }) => {
    return (
        <ScoopRow className={styles.container}>
            <ScoopRow className={styles.messageBubble}>
                <ScoopText className={styles.messageText}>{message.text}</ScoopText>
                <UserCircleIcon size={28} color={styles.iconColor} className={styles.userIcon} />
            </ScoopRow>
        </ScoopRow>
    )
}
